"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nbNO = exports.enUS = void 0;
const utils_1 = require("../FilterBoxDateTime/utils");
const CURRENT_YEAR = new Date().getFullYear();
exports.enUS = {
    components: {
        MneBetaButtonSimple: {
            defaultProps: {
                getOkButtonText: (beta) => `Turn beta ${beta ? "off" : "on"}`,
                cancelButtonText: "Cancel",
                getBetaButtonText: (beta) => (beta ? "Beta" : "Go to beta"),
            },
        },
        CreateButton: {
            defaultProps: {
                createButtonText: "Create",
            },
        },
        Filter: {
            defaultProps: {
                closeText: "Close",
                applyText: "Apply",
            },
        },
        MneSidebarLeftSavedFilters: {
            defaultProps: {
                header: "Saved search filters",
                iconButtonText: "Filters",
            },
        },
        AutocompleteOptionFunction: {
            defaultProps: {
                readOnlyText: "Read-only",
                roleText: "Role",
                functionText: "Function",
                roleTypeTexts: {
                    service: "Service",
                    case: "Case",
                    tool: "Tool",
                    other: "Other",
                },
            },
        },
        ColumnSelectorPopover: {
            defaultProps: {
                title: "Visible columns",
                buttonResetText: "Reset to default",
            },
        },
        ColumnSelectorSearch: {
            defaultProps: {
                placeholder: "Search...",
            },
        },
        ColumnSelectorList: {
            defaultProps: {
                EmptyStateProps: {
                    title: "Nothing to show",
                    description: "There is no columns to select",
                },
            },
        },
        DateTimeFilterActions: {
            defaultProps: {
                applyText: "Apply",
                cancelText: "Cancel",
            },
        },
        DateTimeFilterTabs: {
            defaultProps: {
                tabs: [
                    { label: "Relative", value: "relative" },
                    { label: "Absolute", value: "absolute" },
                    { label: "Now", value: "now" },
                ],
            },
        },
        DateTimeFilterQuickSelect: {
            defaultProps: {
                label: "Quick select",
                optionGroups: [
                    {
                        options: [
                            { label: "Last 60 minutes", value: utils_1.relativeDateTimePresets.last60Minutes },
                            { label: "Last 12 hours", value: utils_1.relativeDateTimePresets.last12Hours },
                            { label: "Last 24 hours", value: utils_1.relativeDateTimePresets.last24Hours },
                            { label: "Last 7 days", value: utils_1.relativeDateTimePresets.last7Days },
                            { label: "Last 30 days", value: utils_1.relativeDateTimePresets.last30Days },
                            { label: "Current year", value: utils_1.relativeDateTimePresets.currentYear },
                            { label: "Previous day", value: utils_1.relativeDateTimePresets.previousDay },
                            { label: "Previous week", value: utils_1.relativeDateTimePresets.previousWeek },
                            { label: "Previous month", value: utils_1.relativeDateTimePresets.previousMonth },
                            { label: "Previous quarter", value: utils_1.relativeDateTimePresets.previousQuarter },
                            { label: "Previous year", value: utils_1.relativeDateTimePresets.previousYear },
                        ],
                    },
                    {
                        options: [
                            { label: `Q2 ${CURRENT_YEAR}`, value: utils_1.relativeDateTimePresets.quarter2CurrentYear },
                            { label: `Q1 ${CURRENT_YEAR}`, value: utils_1.relativeDateTimePresets.quarter1CurrentYear },
                            { label: `Q4 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.quarter4PreviousYear },
                            { label: `Q3 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.quarter3PreviousYear },
                            { label: `Q2 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.quarter2PreviousYear },
                            { label: `Q1 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.quarter1PreviousYear },
                            { label: `H2 ${CURRENT_YEAR}`, value: utils_1.relativeDateTimePresets.half2CurrentYear },
                            { label: `H1 ${CURRENT_YEAR}`, value: utils_1.relativeDateTimePresets.half1CurrentYear },
                            { label: `H2 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.half2PreviousYear },
                            { label: `H1 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.half1PreviousYear },
                            { label: `${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.previousYear },
                            { label: `${CURRENT_YEAR - 2}`, value: utils_1.relativeDateTimePresets.twoYearsAgo },
                            { label: `${CURRENT_YEAR - 3}`, value: utils_1.relativeDateTimePresets.threeYearsAgo },
                        ],
                    },
                ],
            },
        },
        DateTimeFilterRelative: {
            defaultProps: {
                startOfUnitCheckboxLabelProps: { label: "From start of unit" },
                unitsTextFieldLabel: "Unit",
                expressionSwitchLabelProps: { label: "Expression" },
                units: [
                    { label: "Seconds ago", value: "-seconds" },
                    { label: "Minutes ago", value: "-minutes" },
                    { label: "Hours ago", value: "-hours" },
                    { label: "Days ago", value: "-days" },
                    { label: "Weeks ago", value: "-weeks" },
                    { label: "Months ago", value: "-months" },
                    { label: "Years ago", value: "-years" },
                    { label: "Quarters ago", value: "-quarters" },
                    { label: "Seconds from now", value: "seconds" },
                    { label: "Minutes from now", value: "minutes" },
                    { label: "Hours from now", value: "hours" },
                    { label: "Days from now", value: "days" },
                    { label: "Weeks from now", value: "weeks" },
                    { label: "Months from now", value: "months" },
                    { label: "Years from now", value: "years" },
                    { label: "Quarters from now", value: "quarters" },
                ],
            },
        },
        DateTimeFilterStart: {
            defaultProps: {
                nowButtonText: "Set start to now",
                absoluteInputLabel: "From",
                relativeExpressionInputLabel: "From",
                relativeAmountTextFieldLabel: "From",
                relativeQuickSelectOptions: [
                    { label: "1 hour", value: { id: "1Hour", preset: "now - 1 hour" } },
                    { label: "12 hours", value: { id: "12Hours", preset: "now - 12 hours" } },
                    { label: "24 hours", value: { id: "24Hours", preset: "now - 24 hours" } },
                    { label: "month", value: { id: "1Month", preset: "now - 1 month" } },
                    { label: "3 months", value: { id: "3months", preset: "now - 3 months" } },
                    { label: "6 months", value: { id: "6Months", preset: "now - 6 months" } },
                    { label: "year", value: { id: "1Year", preset: "now - 1 year" } },
                ],
            },
        },
        DateTimeFilterEnd: {
            defaultProps: {
                nowButtonText: "Set end to now",
                absoluteInputLabel: "To",
                relativeExpressionInputLabel: "To",
                relativeAmountTextFieldLabel: "To",
                relativeQuickSelectOptions: [
                    { label: "1 hour", value: { id: "1Hour", preset: "now - 1 hour" } },
                    { label: "12 hours", value: { id: "12Hours", preset: "now - 12 hours" } },
                    { label: "24 hours", value: { id: "24Hours", preset: "now - 24 hours" } },
                    { label: "month", value: { id: "1Month", preset: "now - 1 month" } },
                    { label: "3 months", value: { id: "3months", preset: "now - 3 months" } },
                    { label: "6 months", value: { id: "6Months", preset: "now - 6 months" } },
                    { label: "year", value: { id: "1Year", preset: "now - 1 year" } },
                ],
            },
        },
        DateTimeFieldStrategy: {
            defaultProps: { title: "Date fields to search" },
        },
        FilterBoxDateTime: {
            defaultProps: {
                startButtonPlaceholder: "From date",
                endButtonPlaceholder: "To date",
            },
        },
        ButtonWithPopoverFallback: {
            defaultProps: {
                title: "Something went wrong",
            },
        },
        NotificationPolicyContainer: {
            defaultProps: {
                tooltipText: "severity is not standard for this category",
            },
        },
        SeverityTag: {
            defaultProps: {
                toText: (severity) => {
                    if (severity === "none")
                        return "none";
                    if (severity === "low")
                        return "low";
                    if (severity === "medium")
                        return "medium";
                    if (severity === "high")
                        return "high";
                    if (severity === "critical")
                        return "critical";
                    return severity;
                },
            },
        },
    },
};
exports.nbNO = {
    components: {
        MneBetaButtonSimple: {
            defaultProps: {
                getOkButtonText: (beta) => `Skru beta ${beta ? "av" : "på"}`,
                cancelButtonText: "Avbryt",
                getBetaButtonText: (beta) => (beta ? "Beta" : "Gå til beta"),
            },
        },
        CreateButton: {
            defaultProps: {
                createButtonText: "Opprett",
            },
        },
        Filter: {
            defaultProps: {
                closeText: "Lukk",
                applyText: "Lagre",
            },
        },
        MneSidebarLeftSavedFilters: {
            defaultProps: {
                header: "Lagrede søkefiltre",
                iconButtonText: "Filtre",
            },
        },
        AutocompleteOptionFunction: {
            defaultProps: {
                readOnlyText: "Kun lesetilgang",
                roleText: "Rolle",
                functionText: "Funksjon",
                roleTypeTexts: {
                    service: "Service",
                    case: "Sak",
                    tool: "Verktøy",
                    other: "Andre",
                },
            },
        },
        ColumnSelectorPopover: {
            defaultProps: {
                title: "Synlige kolonner",
                buttonResetText: "Tilbakestill alle valg",
            },
        },
        ColumnSelectorSearch: {
            defaultProps: {
                placeholder: "Søk...",
            },
        },
        ColumnSelectorList: {
            defaultProps: {
                EmptyStateProps: {
                    title: "Ingen kolonner",
                    description: "Ingen kolonner tilgjengelig",
                },
            },
        },
        DateTimeFilterActions: {
            defaultProps: {
                applyText: "Lagre",
                cancelText: "Avbryt",
            },
        },
        DateTimeFilterTabs: {
            defaultProps: {
                tabs: [
                    { label: "Relativ", value: "relative" },
                    { label: "Absolut", value: "absolute" },
                    { label: "Nå", value: "now" },
                ],
            },
        },
        DateTimeFilterQuickSelect: {
            defaultProps: {
                label: "Raskt valg",
                optionGroups: [
                    {
                        options: [
                            { label: "Siste 60 minuter", value: utils_1.relativeDateTimePresets.last60Minutes },
                            { label: "Siste 12 timer", value: utils_1.relativeDateTimePresets.last12Hours },
                            { label: "Siste 24 timer", value: utils_1.relativeDateTimePresets.last24Hours },
                            { label: "Siste 7 dager", value: utils_1.relativeDateTimePresets.last7Days },
                            { label: "Siste 30 dager", value: utils_1.relativeDateTimePresets.last30Days },
                            { label: "I år", value: utils_1.relativeDateTimePresets.currentYear },
                            { label: "I går", value: utils_1.relativeDateTimePresets.previousDay },
                            { label: "Forrige uke", value: utils_1.relativeDateTimePresets.previousWeek },
                            { label: "Forrige måned", value: utils_1.relativeDateTimePresets.previousMonth },
                            { label: "Forrige kvartal", value: utils_1.relativeDateTimePresets.previousQuarter },
                            { label: "I fjor", value: utils_1.relativeDateTimePresets.previousYear },
                        ],
                    },
                    {
                        options: [
                            { label: `Q2 ${CURRENT_YEAR}`, value: utils_1.relativeDateTimePresets.quarter2CurrentYear },
                            { label: `Q1 ${CURRENT_YEAR}`, value: utils_1.relativeDateTimePresets.quarter1CurrentYear },
                            { label: `Q4 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.quarter4PreviousYear },
                            { label: `Q3 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.quarter3PreviousYear },
                            { label: `Q2 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.quarter2PreviousYear },
                            { label: `Q1 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.quarter1PreviousYear },
                            { label: `H2 ${CURRENT_YEAR}`, value: utils_1.relativeDateTimePresets.half2CurrentYear },
                            { label: `H1 ${CURRENT_YEAR}`, value: utils_1.relativeDateTimePresets.half1CurrentYear },
                            { label: `H2 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.half2PreviousYear },
                            { label: `H1 ${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.half1PreviousYear },
                            { label: `${CURRENT_YEAR - 1}`, value: utils_1.relativeDateTimePresets.previousYear },
                            { label: `${CURRENT_YEAR - 2}`, value: utils_1.relativeDateTimePresets.twoYearsAgo },
                            { label: `${CURRENT_YEAR - 3}`, value: utils_1.relativeDateTimePresets.threeYearsAgo },
                        ],
                    },
                ],
            },
        },
        DateTimeFilterRelative: {
            defaultProps: {
                startOfUnitCheckboxLabelProps: { label: "Fra start av unit" },
                unitsTextFieldLabel: "Unit",
                expressionSwitchLabelProps: { label: "Tidsuttrykk" },
                units: [
                    { label: "Sekunder siden", value: "-seconds" },
                    { label: "Minuter siden", value: "-minutes" },
                    { label: "Timer siden", value: "-hours" },
                    { label: "Dager siden", value: "-days" },
                    { label: "Uker siden", value: "-weeks" },
                    { label: "Måneder", value: "-months" },
                    { label: "År siden", value: "-years" },
                    { label: "Kvartaler siden", value: "-quarters" },
                    { label: "Sekunder fra nå", value: "seconds" },
                    { label: "Minuter fra nå", value: "minutes" },
                    { label: "Timer fra nå", value: "hours" },
                    { label: "Dager fra nå", value: "days" },
                    { label: "Uker fra nå", value: "weeks" },
                    { label: "Måneder fra nå", value: "months" },
                    { label: "År fra nå", value: "years" },
                    { label: "Kvartaler fra nå", value: "quarters" },
                ],
            },
        },
        DateTimeFilterStart: {
            defaultProps: {
                nowButtonText: "Sett start til nå",
                absoluteInputLabel: "Fra",
                relativeExpressionInputLabel: "Fra",
                relativeAmountTextFieldLabel: "Fra",
                relativeQuickSelectOptions: [
                    { label: "1 time", value: { id: "1Hour", preset: "now - 1 hour" } },
                    { label: "12 timer", value: { id: "12Hours", preset: "now - 12 hours" } },
                    { label: "24 timer", value: { id: "24Hours", preset: "now - 24 hours" } },
                    { label: "Måned", value: { id: "1Month", preset: "now - 1 month" } },
                    { label: "3 måneder", value: { id: "3months", preset: "now - 3 months" } },
                    { label: "6 måneder", value: { id: "6Months", preset: "now - 6 months" } },
                    { label: "År", value: { id: "1Year", preset: "now - 1 year" } },
                ],
            },
        },
        DateTimeFilterEnd: {
            defaultProps: {
                nowButtonText: "Sett slutt til nå",
                absoluteInputLabel: "Til",
                relativeExpressionInputLabel: "Til",
                relativeAmountTextFieldLabel: "Til",
                relativeQuickSelectOptions: [
                    { label: "1 time", value: { id: "1Hour", preset: "now - 1 hour" } },
                    { label: "12 timer", value: { id: "12Hours", preset: "now - 12 hours" } },
                    { label: "24 timer", value: { id: "24Hours", preset: "now - 24 hours" } },
                    { label: "Måned", value: { id: "1Month", preset: "now - 1 month" } },
                    { label: "3 måneder", value: { id: "3months", preset: "now - 3 months" } },
                    { label: "6 måneder", value: { id: "6Months", preset: "now - 6 months" } },
                    { label: "År", value: { id: "1Year", preset: "now - 1 year" } },
                ],
            },
        },
        DateTimeFieldStrategy: {
            defaultProps: { title: "Datofelter å søke" },
        },
        FilterBoxDateTime: {
            defaultProps: {
                startButtonPlaceholder: "Fra dato",
                endButtonPlaceholder: "Til dato",
            },
        },
        ButtonWithPopoverFallback: {
            defaultProps: {
                title: "Noe gikk galt",
            },
        },
        NotificationPolicyContainer: {
            defaultProps: {
                tooltipText: "alvorlighetsgrad er ikke standard for denne kategorien",
            },
        },
        SeverityTag: {
            defaultProps: {
                toText: (severity) => {
                    if (severity === "none")
                        return "ingen";
                    if (severity === "low")
                        return "lav";
                    if (severity === "medium")
                        return "medium";
                    if (severity === "high")
                        return "høy";
                    if (severity === "critical")
                        return "kritisk";
                    return severity;
                },
            },
        },
    },
};
